<div id="no-funded-loans-card" class="card-base flex flex-col gap-6 items-center justify-center px-8 py-6">
  <p
    id="no-funded-loans-message"
    class="font-dm font-normal text-base leading-6 text-center text-ld-neutral-700 m-0"
    [innerHTML]="message"
  ></p>
</div>
